export default [
  {
    title: 'Encoder',
    gjIcon: 'Section',
    children: [
      {
        title: 'Dashboard',
        route: 'encoder-dashboard',
      },
      {
        title: 'Live Hubs',
        route: 'live-hubs',
        tag: 'Beta',
        tagVariant: 'light-primary',
      },
      {
        title: 'Live Jobs',
        route: 'live-encoder',
        tag: 'Beta',
        tagVariant: 'light-primary',
      },
      {
        title: 'Jobs',
        route: 'jobs',
      },
      {
        title: 'Job Templates',
        route: 'job-templates',
      },
      {
        title: 'Output Presets',
        route: 'output-presets',
      },
      {
        title: 'DRM',
        route: 'drm',
      },
    ],
  },
]
